
var sprite = require("/home/romain/Cozy/cozy-proxy/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 52 52\" id=\"icon-clipboard_c712148db806041fe6a57b441ca9ae1a\" ><title>icon-clipboard</title><g stroke=\"#FFF\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M35.996 47l-7 2 2-7L46 26.998l5 5zM42 30.998l5 5M30.996 42l5 5M24 45H9c-2.2 0-4-1.8-4-4V9h8\"/><path d=\"M23 41H9V13h4M37 22V9h-8\"/><path d=\"M25 7c0-1.656-1-4-4-4s-4 2.344-4 4h-4v8h16V7h-4zM29 13h4v9M15 21h10M15 25h10M15 29h10M15 33h6\"/></g></symbol>";
module.exports = sprite.add(image, "icon-clipboard_c712148db806041fe6a57b441ca9ae1a");


//////////////////
// WEBPACK FOOTER
// ./app/assets/sprites/icon-clipboard.svg
// module id = 89
// module chunks = 0